import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment } from 'src/environments/environment';
import { AppModule } from './app/app.module';

// const isMobileResolution = () => {
//     return window.innerWidth <= environment.MOBILE_PORTAL.RESOLUTION;
// };

// const redirectToApp = () => {
//     if (isMobileResolution()) {
//         window.location.href = environment.MOBILE_PORTAL.URL;
//     }
// };

// redirectToApp();

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
